export class LicenseInformation {
  public Status: number;
  public Message: string;
  public SepidzWebKind: SoftWareLicenseKind;
  public RestaurantLightWeb: SoftWareLicenseKind;
  public RestaurantCallCenterKind: SoftWareLicenseKind;
  public RestaurantMediumWeb: SoftWareLicenseKind;
  public AccountingAdvancedWeb: SoftWareLicenseKind;
  public AccountingWeb: SoftWareLicenseKind;
  public IsRestaurantBranch: SoftWareLicenseKind;
  public InventoryWeb: SoftWareLicenseKind;
  public InventoryAdvancedWeb: SoftWareLicenseKind;
  public AccountingKind: SoftWareLicenseKind;
  public InventoryKind: SoftWareLicenseKind;
  public ReservedKind: SoftWareLicenseKind;
  public TreasuryKind: SoftWareLicenseKind;
  public SellKind: SoftWareLicenseKind;
  public SellWeb: SoftWareLicenseKind;
  public SaleInventory: boolean;
  public TreasuryWeb: SoftWareLicenseKind;
  public PayrollWeb: SoftWareLicenseKind;
  public PayrollKind: SoftWareLicenseKind;
  public RestaurantAdvancedWeb: SoftWareLicenseKind;
  public SmartEvaluation: SoftWareLicenseKind;
  public SmartPrecision: SoftWareLicenseKind;
  public RestaurantBranchManagementAdvancedKind: SoftWareLicenseKind;
  public RestaurantBranchManagementLightKind: SoftWareLicenseKind;
  public RestaurantBranchManagementLight: boolean;
  public ProductVersion: string;
  public CustomerName: string;
  public SepidzWebUserCount?: number;
  public WebCallCenterUser?: number;
  public SmsAdvertisingNumber: string;
  public SmsServiceNumber: string;
  public RestaurantAddress: string;
  public BrandName: string;
  public BranchingLightEnabled: boolean;
  public BranchingCount: number;
  public BranchingAdvancedEnabled: boolean;
  public HasSecurityReview: boolean;
  public HasShortMessage: boolean;
  public LockNumber?: number;
  public HasClub: boolean;
  public OrderServices: boolean;
  public RestaurantSms: boolean;
  public MeliBank: boolean;
  public ParsianBank: boolean;
  public PasargadBank: boolean;
  public EghtesadNovinBank: boolean;
  public MellatBank: boolean;
  public PersianSwitch: boolean;
  public ShahrBank: boolean;
  public SamanBank: boolean;
  public IranKishBank: boolean;
  public DigitalMenu: boolean;
  public PaymentPanelAVA: boolean;
  public OnlineSalesSnapFood: boolean;
  public RestaurantCallCenter: boolean;
  public SafirCourierFleetManagement: boolean;
  public SafirApiKey: string;
  public LastVersion: string;
  public SpeedzFactorLink: boolean;
  public HasUpdate: boolean;
  public HasProtel: boolean;
  public OnlineMenu: boolean;
  public SafirToken: string;
}
export class InfoValidation {
  public Status: number;
  public Message: string;
  constructor() {
    this.Status = null;
    this.Message = null;
  }
}
export enum SoftWareLicenseKind {
  // سرویس سفارشات نسخه مدیریت شعب پیشرفته
  OrderServices = 15,
  // نرم افزار سپیدز نسخه مدیریت شعب پیشرفته
  RestaurantBranchManagementAdvanced = 16,

  /// <summary>
  /// نرم افزار سپیدز نسخه مدیریت شعب لایت
  /// </summary>
  RestaurantBranchManagementLight = 17,

  /// <summary>
  /// نرم افزار سپیدز نسخه پیام کوتاه
  /// </summary>
  RestaurantSms = 18,

  /// <summary>
  /// نرم افزار تحت وب سپیدز نسخه لایت
  /// </summary>
  RestaurantCallCenter = 20,

  /// <summary>
  /// نرم افزار تحت وب سپیدز نسخه لایت
  /// </summary>
  HasClub = 36,

  /// <summary>
  /// نرم افزار تحت وب سپیدز نسخه لایت
  /// </summary>
  RestaurantLightWeb = 37,

  /// <summary>
  /// نرم افزار تحت وب سپیدز نسخه فروش
  /// </summary>
  RestaurantMediumWeb = 38,

  /// <summary>
  /// نرم افزار تحت وب سپیدز نسخه فروش و انبار
  /// </summary>
  RestaurantAdvancedWeb = 39,

  /// <summary>
  /// تبدیل فروش لایت به نسخه فروش وب
  /// </summary>
  RestaurantLightWebToMediumWeb = 40,

  /// <summary>
  ///تبدیل نسخه لایت به فروش و انبار تحت وب
  /// </summary>
  RestaurantLightWebToAdvancedWeb = 41,

  /// <summary>
  ///تبدیل نسخه فروش به فروش و انبار تحت وب
  /// </summary>
  RestaurantMediumWebToAdvancedWeb = 42,

  /// <summary>
  /// نرم افزار سیپیدز شعبه مدیریت شعب
  /// </summary>
  IsRestaurantBranch = 52,

  /// <summary>
  /// تبدیل مدیریت شعب لایت به پیشرفته
  /// </summary>
  RestaurantBranchManagementLightToAdvance = 54,

  /// <summary>
  /// نرم افزار سپیدز نسخه وب حسابداری دوبل سیما
  /// </summary>
  AccountingWeb = 72,

  /// <summary>
  /// نرم افزار سپیدز نسخه وب حسابداری دوبل پیشرفته سیما
  /// </summary>
  AccountingAdvancedWeb = 73,

  /// <summary>
  /// نرم افزار سپیدز نسخه وب انبار بازرگانی(چند واحدی) سیما
  /// </summary>
  InventoryWeb = 74,

  /// <summary>
  /// نرم افزار سپیدز نسخه وب انبار تولیدی (چند واحدی) سیما
  /// </summary>
  InventoryAdvancedWeb = 75,

  /// <summary>
  /// نرم افزار سپیدز نسخه وب فروش بازرگانی سیما
  /// </summary>
  SellWeb = 76,

  /// <summary>
  /// نرم افزار سپیدز نسخه وب دریافت و پرداخت(خزانه داری) سیما
  /// </summary>
  TreasuryWeb = 77,

  /// <summary>
  /// نرم افزار نسخه وب حقوق ودستمزد
  /// </summary>
  PayrollWeb = 78,

  /// <summary>
  /// نرم افزار سپیدز نسخه وب حقوق و دستمزد پیشرفته سیما
  /// </summary>
  PayrollAdvanceWeb = 79,

  /// <summary>
  /// تبدیل انبار بازرگانی وب به انبار تولیدی وب
  /// </summary>
  InventoryToAdvancedWeb = 60,

  /// <summary>
  /// تبدیل حسابداری ساده وب به پیشرفته وب
  /// </summary>
  AccountingToAdvancedWeb = 61,

  /// <summary>
  /// نرم افزار تحت وب سپیدز نسخه مدیریت ناوگان پیک
  /// </summary>
  SafirCourierFleetManagement = 89,
}
